module.exports = "<div class=\"container d-flex flex-column offset-lg-1 col-lg-10\">\n  <h2>Accommodation</h2>\n  <p>Accommodation for the conference participation is provided by the organizers. It covers hotel and meals. Its expenses are included in the conference costs.</p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/rzonsol/WebstormProjects/ammpb2/src/app/accommodation/accommodation.component.html
// module id = ../../../../../src/app/accommodation/accommodation.component.html
// module chunks = main